import { ROLES } from '@/constants/roles';

export default [
  {
    path: '/providers',
    name: 'providers',
    component: () => import('@/views/pages/providers/ProvidersList.vue'),
    meta: {
      pageTitle: 'Providers',
      breadcrumb: 'Providers',
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN],
      verticalMenu: {
        title: 'Providers',
        icon: 'TruckIcon'
      }
    }
  },
  {
    path: '/providers/:id/regions',
    redirect: '/providers/:id/regions/information',
    name: 'regions_list_content',
    component: () => import('@/views/pages/providers/ProviderRegionContent.vue'),
    meta: {
      pageTitle: 'Provider List',
      breadcrumb: {
        label: 'Carrier Insights',
        parent: 'providers'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    },
    children: [
      {
        path: '/providers/:id/regions/information',
        name: 'customer_regions_price_list',
        component: () => import('@/views/pages/providers/RegionInformation.vue'),
        meta: {
          pageTitle: 'Carrier Insights',
          breadcrumb: {
            label: 'Provider Region Price'
          }
        }
      },
      {
        path: '/providers/:id/regions/list',
        name: 'customer_regions_list',
        component: () => import('@/views/pages/providers/ProviderRegionList.vue'),
        meta: {
          pageTitle: 'Provider List',
          breadcrumb: {
            label: 'Provider List'
          }
        }
      },
      {
        path: '/providers/:id/regions/pricing/create',
        name: 'create_region_pricing',
        component: () => import('@/views/pages/providers/CreateRegionPricing.vue'),
        meta: {
          pageTitle: 'Add New Pricing',
          breadcrumb: {
            label: 'Add New Pricing'
          }
        }
      },
      {
        path: '/providers/:id/regions/create',
        name: 'create_provider_region',
        component: () => import('@/views/pages/providers/CreateProviderRegion.vue'),
        meta: {
          breadcrumb: {
            label: 'Add New Region'
          }
        }
      }
    ]
  },
  {
    path: '/providers/:id/regions/:region_id',
    name: 'provider_region_detail',
    component: () => import('@/views/pages/providers/EditProviderRegion.vue'),
    meta: {
      pageTitle: 'Provider Region/Country Infos',
      breadcrumb: {
        label: 'Provider Region/Country Infos',
        parent: 'customer_regions_list'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  },
  {
    path: '/providers/:id/additional-fees',
    name: 'providers-additional-fees',
    component: () => import('@/views/pages/providers/ProvidersAdditionalFees.vue'),
    meta: {
      pageTitle: 'Provider Additional Fee List',
      breadcrumb: {
        label: 'Provider Additional Fee List',
        parent: 'providers'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  },
  {
    path: '/providers/:id/additional-fees/create',
    name: 'create-provider-additional-fees',
    component: () => import('@/views/pages/providers/CreateProviderAdditionalFee.vue'),
    meta: {
      pageTitle: 'Add New Additional Fee',
      breadcrumb: {
        label: 'Add New Additional Fee',
        parent: 'providers-additional-fees'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  },
  {
    path: '/providers/:id/additional-fees/:fee_id',
    name: 'edit-provider-additional-fees',
    component: () => import('@/views/pages/providers/EditProviderAdditionalFee.vue'),
    meta: {
      pageTitle: 'Provider Additional Fee Edit',
      breadcrumb: {
        label: 'Provider Additional Fee Edit',
        parent: 'providers-additional-fees'
      },
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN]
    }
  }
];
